import React, { useState, useContext, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";


var debounceTimerTagSearch;

//#tags

const Tags = ({ context, objectType }) => {

    const AppContext = context;

    const [showTagsMenu, setShowTagsMenu] = useState(false);
    const [tagSearchText, setTagSearchText] = useState("");
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [isSearchingTags, setIsSearchingTags] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedStyle, setSelectedStyle] = useState(1);
    const [isLoadingTags, setIsLoadingTags] = useState(false);
    const [isCreatingTag, setIsCreatingTag] = useState(false);
    const [isAddingTag, setIsAddingTag] = useState(false);


    const showTagMenuButton = useRef(null);
    const tagMenu = useRef(null);


    const doTagSearchText = ({ search }) => {
        let debouncingTime = 500;

        if (search == "")
            return;

        setIsLoadingTags(true);

        clearTimeout(debounceTimerTagSearch);

        debounceTimerTagSearch = setTimeout(() => {
            searchTags(search);
        }, debouncingTime);
    };


    const searchTags = (search) => {

        let url = "/Umbraco/Surface/tags/GetTags?search=" + encodeURIComponent(search) + "&objectType=" + objectType;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsSearchingTags(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let jsonObject = JSON.parse(data);

                // Update the task in the existing tasks array
                setSearchResults(jsonObject);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingTags(false);
                setIsSearchingTags(false);

            });

    }


    const handleButtonClick = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (showTagMenuButton.current) {
            const rect = showTagMenuButton.current.getBoundingClientRect();
            // .tag-menu is position:fixed — use viewport coords, not document coords
            const menuWidth = 250;
            const left = Math.min(rect.left, window.innerWidth - menuWidth - 8);
            const top = Math.min(rect.bottom + 8, window.innerHeight - 280);
            setPopupPosition({
                top: Math.max(8, top),
                left: Math.max(8, left),
            });
        }
        setShowTagsMenu(!showTagsMenu);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showTagMenuButton.current && !showTagMenuButton.current.contains(event.target) &&
                tagMenu.current && !tagMenu.current.contains(event.target)) {
                setShowTagsMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const addTag = ({ Id, Text, Style }) => {

        let tagExists = false;

        if (AppContext.currentItem.Tags != null)
            tagExists = AppContext.currentItem.Tags.find((tag) => tag.Id == Id);

        if (!tagExists) {

            let url = "/Umbraco/Surface/tags/AddTagToObject?tagId=" + Id + "&objectType=" + objectType  + "&objectId=" + AppContext.currentItem.Id;

            let requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            setIsAddingTag(true);

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    let updatedTags = AppContext.currentItem.Tags;

                    if (updatedTags == null)
                        updatedTags = [];

                    updatedTags.push({ Id, Text, Style });
                    AppContext.setCurrentItem({ ...AppContext.currentItem, Tags: updatedTags });

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    setShowTagsMenu(false);
                    setIsAddingTag(false);
                });
        }
        else {
            setShowTagsMenu(false);
        }

    }


    const removeTag = ({ Id }) => {

        let url = "/Umbraco/Surface/tags/removeTagFromObject?tagId=" + Id + "&objectType=" + objectType + "&objectId=" + AppContext.currentItem.Id;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response;
            })
            .then((data) => {

                if (data.status == 200) {

                    let updatedTags = AppContext.currentItem.Tags.filter((tag) => tag.Id != Id);
                    AppContext.setCurrentItem({ ...AppContext.currentItem, Tags: updatedTags });

                }


            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {

            });

    }


    const createTag = () => {

        let url = "/Umbraco/Surface/tags/CreateAndAddToObject?text=" + tagSearchText + "&style=" + selectedStyle + "&objectType=" + objectType  + "&objectId=" + AppContext.currentItem.Id;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsCreatingTag(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let newtag = JSON.parse(data);

                let updatedTags = AppContext.currentItem.Tags;

                if (updatedTags == null)
                    updatedTags = [];

                updatedTags.push(newtag);
                AppContext.setCurrentItem({ ...AppContext.currentItem, Tags: updatedTags });

                setTagSearchText("");

                // If there is a function to update a preexisting TagFilter with the new values run that function
                    if (AppContext.callbackUpdateTriggerTagFilter)
                        AppContext.callbackUpdateTriggerTagFilter();

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setShowTagsMenu(false);
                setIsCreatingTag(false); // If coming from the create tag
            });

    }



    return (<>

        {AppContext.userRole == "Admin" ? <>
            <div ref={showTagMenuButton} className="tag-add-button" onClick={handleButtonClick}><i className="fas fa-plus"></i></div>
        </> : null}


        {showTagsMenu && createPortal(
            <div ref={tagMenu} className="tag-menu" style={{
                display: "block",
                top: `${popupPosition.top}px`,
                left: `${popupPosition.left}px`,
            }}>

                <div className="g-mb-20">
                    <input id="tag-search-box" placeholder="Search for your tags" value={tagSearchText} onChange={(e) => {
                        if (!isSearchingTags) {
                            let text = e.target.value;
                            setTagSearchText(text);
                            doTagSearchText({ search: text });
                        }
                    }} style={{ width: "100%", borderRadius: "15px", border: "1px solid #333", padding: "2px 10px 2px 10px" }} type="text" />
                </div>

                {isLoadingTags ?
                    <div id="tag-main-load" style={{ display: "block" }}>
                        <LoadingSpinnerImage />
                    </div>
                    :
                    <div id="tag-main-content">
                        <div className="g-mb-10">
                            <div id="tag-search-results-container">

                                {tagSearchText == "" &&
                                    <div>
                                        Search for tags to add to the item
                                    </div>
                                }

                                {isAddingTag ? <LoadingSpinnerImage /> :

                                    searchResults.map((tag, index) =>

                                        <div key={index} className="tag-container">
                                            <div
                                                onClick={() => addTag({ Id: tag.Id, Text: tag.Text, Style: tag.Style })}
                                                className={`tag-object ellipsis tag-color-ball-${tag.Style}`}>{tag.Text}</div>
                                        </div>

                                    )
                                }

                            </div>
                        </div>


                        {!isAddingTag && tagSearchText != "" && !isSearchingTags && searchResults.filter((tag) => tag.Text == tagSearchText).length == 0 &&
                            <div className="g-mb-10">
                                <div id="tag-create-new-container" style={{ display: "block" }}>
                                    <div>
                                        <hr style={{ margin: "10px 0px" }} />
                                        Create tag with name:
                                        <div id="tag-create-new-text">{tagSearchText}</div>
                                    </div>
                                    <div className="tag-color-ball-container">
                                        <div onClick={() => setSelectedStyle(1)} className={`tag-color-ball tag-color-ball-1 ${selectedStyle == 1 ? "selected" : ""}`} data-style-id="1"></div>
                                        <div onClick={() => setSelectedStyle(2)} className={`tag-color-ball tag-color-ball-2 ${selectedStyle == 2 ? "selected" : ""}`} data-style-id="2"></div>
                                        <div onClick={() => setSelectedStyle(3)} className={`tag-color-ball tag-color-ball-3 ${selectedStyle == 3 ? "selected" : ""}`} data-style-id="3"></div>
                                        <div onClick={() => setSelectedStyle(4)} className={`tag-color-ball tag-color-ball-4 ${selectedStyle == 4 ? "selected" : ""}`} data-style-id="4"></div>
                                        <div onClick={() => setSelectedStyle(5)} className={`tag-color-ball tag-color-ball-5 ${selectedStyle == 5 ? "selected" : ""}`} data-style-id="5"></div>
                                        <div onClick={() => setSelectedStyle(6)} className={`tag-color-ball tag-color-ball-6 ${selectedStyle == 6 ? "selected" : ""}`} data-style-id="6"></div>
                                    </div>
                                    <br />
                                    <div className="tag-color-ball-container">
                                        <div onClick={() => setSelectedStyle(7)} className={`tag-color-ball tag-color-ball-7 ${selectedStyle == 7 ? "selected" : ""}`} data-style-id="7"></div>
                                        <div onClick={() => setSelectedStyle(8)} className={`tag-color-ball tag-color-ball-8 ${selectedStyle == 8 ? "selected" : ""}`} data-style-id="8"></div>
                                        <div onClick={() => setSelectedStyle(9)} className={`tag-color-ball tag-color-ball-9 ${selectedStyle == 9 ? "selected" : ""}`} data-style-id="9"></div>
                                        <div onClick={() => setSelectedStyle(10)} className={`tag-color-ball tag-color-ball-10 ${selectedStyle == 10 ? "selected" : ""}`} data-style-id="10"></div>
                                        <div onClick={() => setSelectedStyle(11)} className={`tag-color-ball tag-color-ball-11 ${selectedStyle == 11 ? "selected" : ""}`} data-style-id="11"></div>
                                        <div onClick={() => setSelectedStyle(12)} className={`tag-color-ball tag-color-ball-12 ${selectedStyle == 12 ? "selected" : ""}`} data-style-id="12"></div>
                                    </div>
                                    <br />
                                    {isCreatingTag ?
                                        <div id="new-tag-load-container" style={{ display: "block", textAlign: "center" }} >
                                            <LoadingSpinnerImage />
                                        </div>
                                        :
                                        <div id="tag-create-button-container" style={{ justifyContent: "center", display: "flex" }} >
                                            <input onClick={createTag} id="tag-create-button" className="btn btn-primary" type="button" value="Create tag" />
                                        </div>}


                                </div>
                            </div>
                        }

                    </div>

                }


            </div>
        , document.body)}


        {AppContext.currentItem != null && AppContext.currentItem.Tags != null && AppContext.currentItem.Tags.map((tag, index) => (

            <div key={index} className={`tag-object ellipsis tag-color-ball-${tag.Style}`}>{tag.Text}

                {AppContext.userRole == "Admin" ? <>
                    <span style={{
                        color: "#FFF",
                        marginLeft: "3px",
                        fontSize: "0.9rem",
                    }}
                        onClick={() => removeTag({ Id: tag.Id })}

                    ><i className="fas fa-times"></i></span>
                </> : null}

            </div>

        ))
        }



    </>);
}



//#tagfilter

const TagFilter = ({ context, objectType }) => {

    const AppContext = context;

    const [tags, setTags] = useState([]);
    const [showTagFilterMenu, setShowTagFilterMenu] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

    const showTagFilterMenuButton = useRef(null);
    const tagFilterMenu = useRef(null);

    useEffect(() => {

        let url = "/Umbraco/Surface/tags/GetTags?search=&objectType=" + objectType;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let jsonObject = JSON.parse(data);

                setTags(jsonObject);
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {

            });


    }, [context.tagFilterUpdateTrigger]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showTagFilterMenuButton.current && !showTagFilterMenuButton.current.contains(event.target) &&
                tagFilterMenu.current && !tagFilterMenu.current.contains(event.target)) {
                setShowTagFilterMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const handleButtonClick = () => {
        if (showTagFilterMenuButton.current) {
            const rect = showTagFilterMenuButton.current.getBoundingClientRect();
            setPopupPosition({
                top: rect.bottom + window.scrollY + 10,
                left: rect.left + window.scrollX - 160,
            });
        }
        setShowTagFilterMenu(!showTagFilterMenu);
    };


    const handleCheckboxChange = (event) => {
        const id = parseInt(event.target.value);

        // Doesn't add more tags to selected if still loading data
        if (AppContext.isLoadingData) {
            event.target.checked = !event.target.checked;
            return;
        }

        if (event.target.checked) {
            // Add tag to the array if the checkbox is checked and not yet selected

            if (!AppContext.selectedTags.find((tag) => tag.Id == id)) {
                let tag = tags.find((tag) => tag.Id == id);
                AppContext.setSelectedTags([...AppContext.selectedTags, tag]); // this will trigger refresh on loadReferences (useeffect)
            }

        } else {
            // Remove the tag from the array if the checkbox is unchecked
            AppContext.setSelectedTags(AppContext.selectedTags.filter((tag) => tag.Id !== id)); // this will trigger refresh on loadReferences (useeffect)
        }

    };

    const clearAllTags = () => {

        if (AppContext.isLoadingData)
            return;

        AppContext.setSelectedTags([]);

    }




    return (
        <>





            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: "15px" }}>
                <span>
                    <span ref={showTagFilterMenuButton} onClick={handleButtonClick} className="pointer sr-menubar-button ellipsis" style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        padding: "7px 15px 7px 15px",
                    }}>
                        <i className="fas fa-filter g-mr-3" style={{ fontSize: "11px", color: "#585f69" }}></i> Tags
                        {AppContext.selectedTags.length > 0 ? ` (${AppContext.selectedTags.length})` : null}
                    </span>
                </span>
            </div>







            {showTagFilterMenu &&
                <div ref={tagFilterMenu} className="tag-menu" style={{
                    display: "block",
                    top: `${popupPosition.top}px`,
                    left: `${popupPosition.left}px`,
                }}>

                    {tags.length !== 0 &&
                        <div style={{ marginBottom: "10px" }}>
                            Filter by tags:
                        </div>}


                    <div className="thin-scrollbar" style={{
                        maxHeight: "150px",
                        overflow: "auto",
                    }}>

                        {tags.length == 0 ? <>

                            <div style={{ textAlign: "center" }}>
                                <span>No tags yet!</span>
                                <br /><br />
                                <span>Create your tags in the reference details screen</span>
                            </div>

                        </>
                            :
                            <>
                                {tags.map((tag, index) => (
                                    <div key={index}>
                                        <input name="selectedFilterTags" onChange={handleCheckboxChange} checked={AppContext.selectedTags.find((t) => t.Id == tag.Id) != null} value={tag.Id} type="checkbox" /> {tag.Text}
                                    </div>
                                ))}
                            </>
                        }


                    </div>

                    {AppContext.selectedTags.length > 0 ?

                        <>
                            <br />
                            <div style={{ textAlign: "center" }}>
                                <span onClick={clearAllTags} style={{

                                    padding: "3px 8px",
                                    borderRadius: "25px",
                                    backgroundColor: "#e3e3e3",
                                    color: "#707070",
                                    margin: "2px",
                                    cursor: "pointer",
                                    fontWeight: "500",
                                    border: "1px solid transparent",
                                    fontSize: "0.9rem",

                                }}>Clear all tags</span>
                            </div>

                            <br />

                            <div className="tag-container">
                                {
                                    AppContext.selectedTags.map((tag, index) => (

                                        <div key={index} className={`tag-object ellipsis tag-color-ball-${tag.Style}`}>{tag.Text}</div>

                                    ))
                                }
                            </div>
                        </>
                        : null}

                </div>
            }



        </>

    );

}




const TagList = ({ tags }) => {

    if (!Array.isArray(tags))
        return <></>

    return <>

        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>

            {tags.map((tag, index) => 
            
                <div key={index} className={`tag-object ellipsis tag-color-ball-${tag.Style} tag-small`} title={tag.Text}>{tag.Text}</div>

            )}
        </div>

    </>

}


export { Tags, TagFilter, TagList };